module.exports = __webpack_public_path__ + "static/img/product_banner_big2_zh.69dc150.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_big2_zh.png
// module id = iRkW
// module chunks = 34